import React from "react";
import { connect } from "react-redux";
import DescriptionField from "./DescriptionField";
import ScriptField from "./ScriptField";
import { canEditRuleFields } from "../rulePermissions";

function RemediationTab({ rule, auth }) {
    const disabled = rule.baseRule === true || !canEditRuleFields(auth, "ruleremediation");

    return (
        <>
            <DescriptionField disabled={disabled} />
            <ScriptField disabled={disabled} />
        </>
    )

}

function mapStateToProps(state) {
    const addRulesPage = state.addRulesPage;
    const auth = state.auth;
    return {
        rule: addRulesPage.rule,
        auth,
    }
}

export default connect(mapStateToProps)(RemediationTab);
